// extracted by mini-css-extract-plugin
module.exports = {"nav":"paging_nav___qzVY","arrow":"paging_arrow__P0HdA","number":"paging_number__H3eAn"};